// Stessa regola del backend (backend/src/utils/password.js).
// Utenti studio e amministratori: almeno 10 caratteri. Account con ruolo cliente: almeno 6. In entrambi i casi almeno una lettera e una cifra.
export const LUNGHEZZA_MINIMA_PASSWORD = 10;
export const LUNGHEZZA_MINIMA_PASSWORD_CLIENTE = 6;
export const lunghezzaMinima = ruolo => (ruolo === 'cliente' ? LUNGHEZZA_MINIMA_PASSWORD_CLIENTE : LUNGHEZZA_MINIMA_PASSWORD);
export const regolaPassword = ruolo => `Almeno ${lunghezzaMinima(ruolo)} caratteri, con almeno una lettera e una cifra.`;
export const REGOLA_PASSWORD = regolaPassword('studio');
export const REGOLA_PASSWORD_CLIENTE = regolaPassword('cliente');

export function validaPassword(password, email, ruolo = 'studio') {
  const minimo = lunghezzaMinima(ruolo);
  if (!password || password.length < minimo) return `La password deve avere almeno ${minimo} caratteri`;
  if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) return 'La password deve contenere almeno una lettera e una cifra';
  if (email && password.toLowerCase() === email.toLowerCase()) return "La password non può essere uguale all'email";
  return null;
}
